import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from "@material-ui/core/Container";
import Hidden from '@material-ui/core/Hidden';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    generatePageURI,
    pagePaths,
    CDN_URI_BASE,
    headerAPI,
    _link,
    prefixURI, 
    profileAPI
} from '../common/utilities';
import styles from './collectionsPage.module.css';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SubPageTemplate from "./templates/SubPageTemplate";
import { pageHeaderData } from "./sampleData/sampleData";
import { TabPanel } from "./templates/TabPanel";
import { MuiThemeProvider, createMuiTheme, useTheme  } from "@material-ui/core/styles";
import ReactImageFallback from "react-image-fallback";
import { Translation, Trans } from "react-i18next";
import axios from "axios";
import { ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import { Link } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import missing_inventory_img from "../images/inventory_missing.png";


const mobileViewLimit = 2;


//const defaultRewardImgPrefix = ('BR' == window._region) ? `${CDN_URI_BASE}/web/inventory/weapons/` : `${CDN_URI_BASE}weapon/`;
const defaultRewardImgPrefix = `${CDN_URI_BASE}/web/inventory/weapons/`;

class CollectionRowPanel extends React.Component{
	constructor(props){
        super(props);
        
	    this.state = {
            collectionItemsCache: {}
            ,contentReady: false
        }
    }


    tabCollectionDetailSkeleton(){

        var collectorsText = 'Collectors';
        var rewardsText = 'Rewards';

        return(
                <Grid container spacing={2} className={styles.selectedCollection}>
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <h6 className={styles.rewardTitle}>&nbsp;</h6>
                        <div className={styles.collectorBoxHeader}>
                            <span className={styles.collectionTitle}>
                                <Skeleton width="172px"height="40px" />
                            </span>
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2}>
                        <h6 className={styles.rewardTitle}>{collectorsText}</h6>
                            <div className={styles.collectorBox}>
                                <div className={styles.numCollectorsBox}></div>
                            </div>
                    </Grid>

                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2}>
                        <h6 className={styles.rewardTitle}>{rewardsText}</h6>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px"height="97px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2}>
                        <h6 className={styles.rewardTitle}>&nbsp;</h6>
                        <div className={styles.collectorBox}>
                            <Skeleton width="180px" height="30px" />
                        </div>
                    </Grid>

                    <div className={styles.collectionDivider}></div>                                        
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={1}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={2}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={3}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={4}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={5}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={6}>
                        <div className={styles.collectorBox}>
                            <Skeleton width="172px" height="30px" />
                        </div>
                    </Grid>
                </Grid>
        );
    }

    generateCollectionDetails(items){
        // put code to generate content here

        var myDisplayItems = [];
        var collectionItemsCache = this.props.collectionItemsCache;

        for(var i = 0; i < items.length; i++){

            myDisplayItems.push(
                <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={i}>
                    <CollectionWeaponImageDetail WeaponInfo={items[i]} />
                </Grid>
            );
        }
/*
    collectionItemsCache[currentCollectionRow[i].collection_ID].name = currentCollectionRow[i].collection_Name;
    collectionItemsCache[currentCollectionRow[i].collection_ID].collection_Group_Name = currentCollectionRow[i].collection_Group_Name;
    collectionItemsCache[currentCollectionRow[i].collection_ID].reward_Type = currentCollectionRow[i].reward_Type;
    collectionItemsCache[currentCollectionRow[i].collection_ID].nameCardImgURL = currentCollectionRow[i].nameCardImgURL;
    collectionItemsCache[currentCollectionRow[i].collection_ID].nameCardText = currentCollectionRow[i].nameCardText;
    collectionItemsCache[currentCollectionRow[i].collection_ID].reward_Desc = currentCollectionRow[i].reward_Desc;
    collectionItemsCache[currentCollectionRow[i].collection_ID].reward_Image = currentCollectionRow[i].reward_Image;
    collectionItemsCache[currentCollectionRow[i].collection_ID].image_Server = currentCollectionRow[i].image_Server;
    collectionItemsCache[currentCollectionRow[i].collection_ID].data = {};
*/                    

        var collectionContainer;

        var collectionsLeaderURL = "/collections/";

        var collectorsTitleText = 'Collectors';
        var completedTitleText = ''; //'Completed Sets';
        var rewardTitleText = 'Rewards';

        var rewardsDataCase = collectionItemsCache.reward_Desc && 
            collectionItemsCache.nameCardImgURL ? 'all' : (
                collectionItemsCache.reward_Desc || collectionItemsCache.nameCardImgURL ? 'one' : 'none');

        var CollectorCountElement = (collectionItemsCache.collectors)
                        ?   <Link to={generatePageURI(
                                pagePaths.COLLECTONS + '/' +
                                collectionItemsCache.id
                            )}>
                                <div className={styles.collectorBoxNum}>
                                    <div className={styles.numCollectorsBox}>{collectionItemsCache.collectors}</div>
                                </div>
                            </Link>
                        :   <div className={styles.collectorBoxNum}>
                                <div className={styles.numCollectorsBox}>{collectionItemsCache.collectors}</div>
                            </div>;

        collectionContainer =   <Translation>
                                {
                                (t) => 
                                    <Grid container spacing={2} className={styles.selectedCollection}>
                                    <Grid item xs={12} sm={6} lg={rewardsDataCase === 'all' ? 6: rewardsDataCase === 'one' ? 8: 10}>
                                    <Hidden xsDown><h6 className={styles.rewardTitle}>&nbsp;</h6></Hidden>
                                        <div className={styles.collectorBoxHeader}>
                                            <span className={styles.collectionTitle}>{collectionItemsCache.name}</span>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={2}>
                                        <h6 className={styles.rewardTitle}><Hidden xsDown>{t(collectorsTitleText)}</Hidden>&nbsp;</h6>
                                        {CollectorCountElement}
                                        <Hidden xsDown><span className={styles.completedSets}>{t(completedTitleText)}</span></Hidden>
                                    </Grid>
                                    {rewardsDataCase !== 'none' &&
                                    <Grid container item xs={12} lg={rewardsDataCase === 'all' ? 4 : 2} direction="column">
                                        <Grid container item justify="flex-end" spacing={2}>
                                            <Grid item xs={12} sm={rewardsDataCase === 'all' ? 12 : 6} lg={12}><h6 className={styles.rewardTitle}>{t(rewardTitleText)}</h6></Grid>
                                        </Grid>
                                        <Grid container spacing={2} justify="flex-end">
                                        {collectionItemsCache.reward_Desc &&
                                            <Grid item xs={rewardsDataCase === 'all' ? 6 : 12} sm={6} lg={rewardsDataCase === 'all' ? 6 : 12}>
                                                <div className={styles.collectorBox + ' ' + styles.collectorBoxReward}>
                                                    <ReactImageFallback
                                                        className={styles.rewardItem}
                                                        src={collectionItemsCache.image_Server + collectionItemsCache.reward_Image}
                                                        fallbackImage={missing_inventory_img}
                                                        alt={collectionItemsCache.reward_Desc}
                                                    />
                                                </div>
                                            <h3>{collectionItemsCache.reward_Desc}</h3>
                                        </Grid>
                                    }
                                    {collectionItemsCache.nameCardImgURL &&
                                        <Grid item xs={rewardsDataCase === 'all' ? 6 : 12} sm={6} lg={rewardsDataCase === 'all' ? 6 : 12}>
                                            <div className={styles.collectorBox + ' ' + styles.collectorBoxReward}>
                                                <ReactImageFallback
                                                    className={styles.namecard}
                                                    src={collectionItemsCache.nameCardImgURL}
                                                    fallbackImage={missing_inventory_img}
                                                    alt={collectionItemsCache.nameCardText}
                                                />
                                            </div>
                                            <h3>{collectionItemsCache.nameCardText}</h3>
                                        </Grid>
                                    }
                                    </Grid>
                                    </Grid>}
                                    
                                    
                                    <div className={styles.collectionDivider}></div>                                        
                                    {myDisplayItems}                                                                                
                                </Grid>
                            }
                            </Translation>;
        return collectionContainer;
    }

    getCollectionDetails(id){
        // weaponcollectiondetails

        //console.log('collection id given: ' + id);

        var apilink = profileAPI;

        var params = {};

        var _this = this;

        params.command = 'weaponcollectiondetails';
        params.usn = this.props.usn;
        params.start = 1;
        params.end = 200;
        params.collection = id;
      
        axios.get(apilink, {params: params})
          .then(function(response){
      
            if(response.data){

                //console.log(response.data)

                if(response.data.APIresult && '000' == response.data.APIresult
                   && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
                   && !response.data.p_o_ErrDesc && response.data.dsCollectionDetailResult
                   && response.data.APImessage && 'OK' == response.data.APImessage){

                  _this.setState({
                        collectionItemsCache: _this.generateCollectionDetails(response.data.dsCollectionDetailResult)
                        ,contentReady: true
                  });

                }else{
                  console.log('FAIL: could not retrieve collection details data due to \'not OK\' response');
                    _this.setState({
                        //collectionItemsCache: false
                    });
                }
              }else{
                console.log('FAIL: could not retrieve collection details means there was no data recieved');
                  _this.setState({
                    counts: []
                  });
              }
          })
          .catch(function (error){
                console.log('FAIL: could not retrieve collection details means there was a caught error');
                console.log(error)
                _this.setState({
                    counts: []
                });
        });        

    }

    render (){

        //console.log(this.props.collectionItemsCache)
        if(this.props.selectedTab == this.props.collection_ID && !this.state.contentReady){
            this.getCollectionDetails(this.props.collection_ID)
        }

        var content = (this.props.selectedTab && this.state.contentReady) ? this.state.collectionItemsCache : this.tabCollectionDetailSkeleton();

        return(
            <TabPanel 
                value={this.props.selectedTab}
                index={this.props.collection_ID}
                key={this.props.collection_ID}
            > 
                <div>{content}</div>
            </TabPanel>            
        );
    }
}

class CollectionTabImageDetail extends React.Component{
	constructor(props){
        super(props);
    }

    render (){

        var currentCollectionRowImgInfo = this.props.currentCollectionRowImgInfo;

        var selectedClass = (this.props.selectedTab == currentCollectionRowImgInfo.collection_ID) ? styles.selectedCollectionTab : null;
        var currentStyle = ('N' != currentCollectionRowImgInfo.completed) ? null : styles.noprogress;
        var currentProgress = currentCollectionRowImgInfo.user_Item_CNT + '/' + currentCollectionRowImgInfo.total_Item_CNT;

        // create tabs

        var missing_img = CDN_URI_BASE + "templates/assets/imgs/collections/collection-missing.png";

        return(
            <div className={selectedClass} key={currentCollectionRowImgInfo.collection_Name}>

                    <ReactImageFallback
                        src={currentCollectionRowImgInfo.collection_Image}
                        className={currentStyle}
                        fallbackImage={missing_img}
                        alt="collection img"
                    />
                    <h3 className={currentStyle}>
                        {currentCollectionRowImgInfo.collection_Name}
                    </h3>
                    <h5 className={currentStyle}>
                        {currentProgress}
                    </h5>
            </div>
        );


    }    
}

class CollectionWeaponImageDetail extends React.Component{
	constructor(props){
        super(props);
    }

    render (){

        var Weapon = this.props.WeaponInfo;

        return(

                <div className="sgw-collection-col">
                    <div className={styles.collectorWeapon}>
                        <div className={'Y' == Weapon.is_Obtained ? styles.checked : styles.unchecked}></div>

                        <ReactImageFallback
                            src={Weapon.image_Server + Weapon.image_URL}
                            fallbackImage={missing_inventory_img}
                            alt={Weapon.item_name}
                            className={'Y' == Weapon.is_Obtained ? '' : styles.uncheckedweapon}
                        />
                    </div>
                    <div className={1 == Weapon.is_Obtained ? 'sgw-arsenal-weapon-text sgw-collection-weapon-text checkedText' : 'sgw-arsenal-weapon-text sgw-collection-weapon-text'}>
                       <h3>{Weapon.item_Name}</h3>
                    </div>
                </div>

        );


    }    
}

// override style on Tab for CollectionPage

var theme = createMuiTheme({
    overrides: {
      MuiTabs: {
        indicator: {
          backgroundColor: 'transparent'
        },
        fixed: {
          overflow: 'inherit !important'
        },
        scroller: {
            overflow: 'inherit !important'
        }
      }
    }
  });

//  const newtheme = useTheme();
//  const mobileView = useMediaQuery(newtheme.breakpoints.down('sm'));  

class CollectionsPageViewer extends React.Component{

	constructor(props){
        super(props);
        
	    this.state = {
            outputList: []
            ,collections: []
            ,collectionRows: []
            ,collectionGroups: []
            ,collectionItemsCache: []
            ,counts: []
            ,completed_CNT: ''
            ,total_CNT: ''
            ,tabItemLimit: this.props.tabItemLimit
            ,contentReady: false
            ,selectedTab: false
            ,errorData: <div><Trans>No data to display</Trans></div>
            ,displayed: false
        }

        this.getCollections();
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(){
        //if(this.state.contentReady){
            //alert('content is ready');
        //}
    }

    collectionSkeleton(){
        return (
            <div style={{width: '180px', float: 'left'}}>
                <Skeleton variant="circle" width="180px" height="180px" />

                <div style={{width: '100px', textAlign: 'center', margin: '0 auto'}}>
                    <Skeleton height={3} width="80%" style={{textAlign: 'center'}}/>
                </div>

                <div style={{width: '50px', textAlign: 'center', margin: '0 auto'}}>
                    <Skeleton height={8} width="60%" style={{textAlign: 'center'}} />
                </div>

            </div>            
        );        
    }


    getCollections(){

        //console.log('getting collections')

        var apilink = profileAPI;

        var params = {};

        var tabItemLimit = this.props.tabItemLimit;

        var _this = this;

        params.command = 'weaponcollection';
        params.usn = this.props.usn;
        params.order = 1; //(default: 1 by group, 2 by most completed)

        axios.get(apilink, {params: params})
          .then(function(response){
      
            if(response.data){

                if(response.data.APIresult && '000' == response.data.APIresult
                   && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
                   && !response.data.p_o_ErrDesc && response.data.dsCollectionResult 
                   && response.data.dsCollectionTotal && response.data.dsCollectionTotal[0]
                   && response.data.dsWeaponCollectionGroupListResult
                   && response.data.APImessage && 'OK' == response.data.APImessage){

                    //console.log('SUCCESS: retrieved user mode data');
                    //console.log(response.data.dsCollectionTotal);
                    //console.log(response.data.dsCollectionResult);

                    // separate into groups
                    //collectionGroups
                    var myCollectionGroups = [];

                    for (var cg=0; cg < response.data.dsWeaponCollectionGroupListResult.length; cg++) {

                        // create collection group and map collection items to it
                        myCollectionGroups.push(response.data.dsWeaponCollectionGroupListResult[cg]);

                        if(response.data.dsCollectionResult.length){
                            myCollectionGroups[cg].members = response.data.dsCollectionResult.filter(function (collection) {
                                return (collection.collection_Group_ID === myCollectionGroups[cg].collection_Group_ID);
                            });
                        }
                        // split the collections into chunks (rows) for output

                        var i,j,temparray, chunk = _this.props.tabItemLimit;
                        temparray = [];
                        for (i=0,j=myCollectionGroups[cg].members.length; i<j; i+=chunk) {
                            temparray.push(myCollectionGroups[cg].members.slice(i,i+chunk));
                            
                            //console.log(response.data.dsCollectionResult.slice(i,i+chunk));
                        }
                        myCollectionGroups[cg].rows = temparray;
                    }

                    //console.log(myCollectionGroups);

                    // create the collections cache (by collection ID)

                    var collectionItemsCache = [];

                    // create the cache of collection information for easy output
                    for (var cg=0; cg < response.data.dsCollectionResult.length; cg++) {

                        // save data for the eventual decloaking (of the Romulans) of the collection's details
                        var currentCollectionID = response.data.dsCollectionResult[cg].collection_ID;

                        collectionItemsCache[currentCollectionID] = {};
                        collectionItemsCache[currentCollectionID].name = response.data.dsCollectionResult[cg].collection_Name;
                        collectionItemsCache[currentCollectionID].id = currentCollectionID;
                        collectionItemsCache[currentCollectionID].collection_Group_Name = response.data.dsCollectionResult[cg].collection_Group_Name;
                        collectionItemsCache[currentCollectionID].reward_Type = response.data.dsCollectionResult[cg].reward_Type;
                        collectionItemsCache[currentCollectionID].nameCardImgURL = response.data.dsCollectionResult[cg].nameCardImgURL;
                        collectionItemsCache[currentCollectionID].nameCardText = response.data.dsCollectionResult[cg].nameCardText;
                        collectionItemsCache[currentCollectionID].reward_Desc = response.data.dsCollectionResult[cg].reward_Desc;
                        collectionItemsCache[currentCollectionID].reward_Image = response.data.dsCollectionResult[cg].reward_Image;
                        collectionItemsCache[currentCollectionID].image_Server = (response.data.dsCollectionResult[cg].image_Server) ? response.data.dsCollectionResult[cg].image_Server : defaultRewardImgPrefix;
                        collectionItemsCache[currentCollectionID].collectors = response.data.dsCollectionResult[cg].completed_CNT;
                        collectionItemsCache[currentCollectionID].data = {};
                        collectionItemsCache[currentCollectionID].contentReady = false;
                    }

                    //console.log(collectionItemsCache);


                  _this.setState({
                      counts: response.data.dsCollectionTotal[0]
                      ,completed_CNT: response.data.dsCollectionTotal[0].completed_CNT
                      ,total_CNT: response.data.dsCollectionTotal[0].total_CNT
                      ,collectionGroups: myCollectionGroups
                      ,collectionItemsCache: collectionItemsCache
                      ,contentReady: true
                  });

                }else{
                  //console.log('FAIL: could not retrieve data due to \'not OK\' repsponse');
                    _this.setState({
                        counts: []
                        ,collections: []
                        ,collectionRows: []
                        ,contentReady: true
                    });
                }
              }else{
                //console.log('FAIL: could not retrieve details');
                  _this.setState({
                    counts: []
                    ,collections: []
                    ,collectionRows: []
                    ,contentReady: true
                  });
              }
          })
          .catch(function (error){
                //console.log('FAIL: could not retrieve details');
                _this.setState({
                    counts: []
                    ,collections: []
                    ,collectionRows: []
                    ,contentReady: true
                });
        });
    }

    handleChange(event, newValue) {

        if(newValue == this.state.selectedTab){
            this.setState({
                selectedTab: false
            });
        }else{
            this.setState({
                selectedTab: newValue
            });
        }
    }

    render (){

        var headingRight = '';
        var disclaimerText = 'Data displayed is updated every 24 hours';
        var GroupedItems = [];
        var titleCollectionOfText = 'Collection of ';
        var TitlePlayerText = ' - Crossfire Player Profile';
        var pageHeading = 'Collections';

        var pageTitle = titleCollectionOfText + `${this.props.headerData?this.props.headerData.NICK:""}` + TitlePlayerText;
        
        if(this.state.contentReady){

            var _this = this;

            this.state.collectionGroups.forEach(function (element) {

                // output groupName
                var collectionRows = element.rows;
                //console.log(element.collection_Group_Name);
                //console.log(collectionRows);
                var collectionItems = [];

                var backgroundString = ( _this.props.tabItemLimit !== mobileViewLimit) ? 'url(' + CDN_URI_BASE + 'templates/assets/imgs/collections/' + element.collection_Group_BGIMAGE + ')' : null;

                //console.log(backgroundString)
                var groupStyle= {backgroundImage: backgroundString};

                for(var k = 0; k < collectionRows.length; k++){
    
                    var panelTabs = [];
                    var panelTabDetails = [];
        
                    // don't center the tabs if there is less than 'tabLimit' - (but hopefully they align)
                    // (but this .... centered = {centertingVariable} does not work)
                    var centertingVariable = (collectionRows[k].length < _this.props.tabItemLimit) ? 'false' : 'true';

                    for(var i = 0; i < collectionRows[k].length; i++){
        
                        var currentCollectionRow = collectionRows[k];
        
                        //console.log(currentCollectionRow[i].collection_Name)
                        //console.log(currentCollectionRow[i].collection_ID)
        
                        panelTabs.push(<Tab key={currentCollectionRow[i].collection_ID} 
                                            icon={<CollectionTabImageDetail selectedTab={_this.state.selectedTab} currentCollectionRowImgInfo={currentCollectionRow[i]} />}
                                            value={currentCollectionRow[i].collection_ID} 
                                            disableRipple
                                            disableFocusRipple
                                            style={{opacity: 1, overflow: 'inherit', padding: '6px'}}
                                        />);
        
                        panelTabDetails.push(   <CollectionRowPanel
                                                    usn={_this.props.usn}
                                                    key={currentCollectionRow[i].collection_ID}
                                                    selectedTab={_this.state.selectedTab}
                                                    collection_ID = {currentCollectionRow[i].collection_ID}
                                                    collectionItemsCache = {_this.state.collectionItemsCache[currentCollectionRow[i].collection_ID]}
                                                />
                        );
                    }
        
                    // create tab row container
                   
                    collectionItems.push(
                        <div key={k}>
                            <Tabs
                                className = {styles.collectionsTab}
                                value={_this.state.selectedTab}
                                onChange={_this.handleChange}
                                scrollButtons="off"
                                aria-label="tabs"
                                style={{overflow: 'inherit', padding: '0 10px'}}
                                variant="fullWidth"
                                centered
                            >
                                {panelTabs}
                            </Tabs>
                            {panelTabDetails}
                        </div>
                    );
                }

                if(collectionItems.length){

                    GroupedItems.push(  <div style={groupStyle} className = {styles.collectionsGroupContainer} key={element.collection_Group_ID}>
                            <h4 className = {styles.collectionsGroupTitle}>{element.collection_Group_Name}</h4>
                            <div className = {styles.collectionsGroupTabsBox}>
                                {collectionItems}
                            </div>
                        </div>
                    );
                }

            });

            var allCollections = <div key='random_key_string' style={{width: '100%'}}>
                                    {GroupedItems}
                                    <div className={styles.disclaimer}><Trans>{disclaimerText}</Trans></div>
                                </div>

            var data = (this.state.total_CNT) ? allCollections : this.state.errorData;

            headingRight = (this.state.total_CNT) ? this.state.completed_CNT + '/' + this.state.total_CNT : '';


            var collectionsChild =  <MuiThemeProvider theme={theme}>
                                        <div className={styles.collections} container spacing={2}>

                                            {data}

                                        </div>
                                    </MuiThemeProvider>

        }else{

            var skeleton = this.collectionSkeleton();
            var collectionsChild =  <MuiThemeProvider theme={theme}>
                                        <div className={styles.collections}>
                                            <div className = {styles.collectionsGroupContainer}>
                                                <div className = {styles.collectionsGroupTabsBox}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={1}>{skeleton}</Grid>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={2}>{skeleton}</Grid>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={3}>{skeleton}</Grid>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={4}>{skeleton}</Grid>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={5}>{skeleton}</Grid>
                                                        <Grid item xs={6} sm={6} md={6} lg={2} xl={2} key={6}>{skeleton}</Grid>
                                                    </Grid>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </MuiThemeProvider>;
        }

        return (
            <Translation>
            {
            (t) => 
            <SubPageTemplate
                title={t(pageTitle)}
                headerData={this.props.headerData}
                headingLeft = {t(pageHeading)}
                headingRight = {headingRight}
            >
                <div className={styles.page_content}>
                    {collectionsChild}
                </div>
            </SubPageTemplate>
            }
            </Translation>
        );        
    }
}


export default function CollectionsPage(props) {

    const { match, devUSN } = props;

    // const [usn, setUSN] = useState();
    const [headerData, setHeaderData] = useState();
    const [pageStatus, setPageStatus] = useState(true);
  
    const usn = devUSN ? devUSN : match ? match.params.usn : null;

    // Similar to componentDidMount and componentDidUpdate:
    //
    // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
    useEffect(() => {
      //api call to set data will be used
      if (usn) {
        axios.get(`${headerAPI}&usn=${usn}`).then(res => {
          if(res.data.p_o_ErrID === 1)
            setHeaderData(res.data.dsProfileHeaderInfo[0]);
          else
             setPageStatus(false);
        });
      }
    }, []);


    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down('xs'));  
    const tabletView = useMediaQuery(theme.breakpoints.down('sm'));
    const deskMdView = useMediaQuery(theme.breakpoints.down('md'));
    const deskLgView = useMediaQuery(theme.breakpoints.down('lg'));

    var tabItemLimit = 6;

    if(deskLgView){
        tabItemLimit = 5;
    }

    if(deskMdView){
        tabItemLimit = 4;
    }

    if(tabletView){
        tabItemLimit = 3;
    }    

    if(mobileView){
        tabItemLimit = 2;
    }

    //console.log(tabItemLimit);

    return (
        <div>
        {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
            <CollectionsPageViewer tabItemLimit={tabItemLimit} headerData={headerData} usn={usn} />
        </div>
    );


}
